import { timingConfig } from "../config";

let documentTitle;
let documentTitleInterval;

const permissionTypes = {
	denied: "denied",
	granted: "granted",
	default: "default",
};

function stopNotificationInDocumentTitle() {
	if (!documentTitleInterval) {
		return;
	}

	document.title = documentTitle;
	clearInterval(documentTitleInterval);
}

export default {
	startNotificationInDocumentTitle(message) {
		stopNotificationInDocumentTitle();

		let count = 0;

		documentTitle = document.title;
		documentTitleInterval = setInterval(() => {
			document.title = count % 2 ? documentTitle : message;
			count = count + 1;
		}, timingConfig.browserTabNotification);
	},
	stopNotificationInDocumentTitle,
	requestDeskNotificationPermission: async() => {
		if (!("Notification" in window)) {
			return;
		}

		if (Notification.permission !== permissionTypes.granted) {
			const response = await Notification.requestPermission();

			return response;
		}

		return Notification.permission;
	},
	sendDesktopNotification({ title, message, options }) {
		if (!("Notification" in window) || Notification.permission === permissionTypes.denied) {
			return;
		}

		const notification = new Notification(title, {
			icon: options.icon,
			badge: options.badge,
			body: message,
		});

		notification.onclick = options.onclick;
	},
};
